export default "__VITE_ASSET__BvCUaxB7__"